import { Box, MenuItem, OutlinedInput, Select } from '@mui/material';

import useStyles from './modalPayBalance/styles';
import ListOfBanks from 'helpers/bankList';

export const AddBankComponent = ({ selectBank, selected, onChangeInput }) => {
    const classes = useStyles();
    return (
        <Box className={classes.modalComponent} style={{ width: '500px' }}>
            <Box
                style={{
                    position: 'absolute',
                    width: '204px',
                    height: '22px',
                    left: '32px',
                    top: '37px'
                }}>
                <label className={classes.addBankAccount}>Add bank account</label>
            </Box>
            <Box
                style={{
                    position: 'absolute',
                    width: '436px',
                    height: '20px',
                    left: '36px',
                    top: '75px'
                }}>
                <label className={classes.addBankSecondaryText}>Select from most common ones</label>
            </Box>
            <Box className={classes.banksContainer} style={{ marginTop: '-16px' }}>
                {ListOfBanks.map((bank, index) => (
                    <button
                        style={{
                            marginTop: '16px',
                            width: '46px',
                            backgroundColor: '#F1F3F7',
                            height: '46px',
                            border: selected === index ? '2px solid #1BABE2' : '1px solid #F1F3F7',
                            borderRadius: '10px',
                            marginRight: '16px'
                        }}
                        onClick={() => {
                            selectBank({ index });
                            onChangeInput('banckName', bank.banckName);
                        }}>
                        <img
                            src={bank.bankIcon}
                            alt={bank.banckName}
                            key={bank.banckName}
                            style={{
                                display: 'flex'
                            }}
                        />
                    </button>
                ))}
            </Box>
            <Box
                style={{
                    marginTop: '244px',
                    marginLeft: '32px'
                }}>
                <Select
                    displayEmpty
                    labelId="selectBankAccount"
                    id="selectBankAccount"
                    value={''}
                    input={<OutlinedInput className={classes.selectOption} />}
                    className={classes.selectComponent}
                    placeholder="Select other bank"
                    style={{
                        width: '426px',
                        height: '40px'
                    }}>
                    <MenuItem disabled value="">
                        <span className={classes.selectOption}>Select other bank</span>
                    </MenuItem>
                </Select>
            </Box>
        </Box>
    );
};
